<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Gerenciar Reunião' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <div class="gradient-extendido"></div>
  <div>
    <ion-grid>
      <ion-row>
        <ion-col>
          <div class="proxima-reuniao-header">
            <div class="icon-text-container">
              <ion-icon *ngIf="reuniao.status === 0" name="time" class="a"></ion-icon>
              <ion-icon *ngIf="reuniao.status === 1" name="checkmark-circle" class="b"></ion-icon>
              <ion-icon *ngIf="reuniao.status === 2" name="remove-circle" class="c"></ion-icon>

              <div class="text-content">
                <ion-label class="color-title">
                  {{reuniao.responsavel}}
                </ion-label>

                <p class="description-text">
                  {{ reuniao.formatada}}
                </p>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="!userProvider.hasConfig(107);" (click)="editarPauta(reuniao.id);">
        <ion-col size="12">
          <ion-list lines="full">
            <ion-item>
              <ion-note slot="start">
                <i class="fa-solid fa-square-pen icon-list icon-gerenciar"></i>
              </ion-note>

              <ion-label>
                <h2 class="text-list" *ngIf="!readOnly">{{'Editar Pauta' | translate}}</h2>
                <h2 class="text-list" *ngIf="readOnly">{{'Pauta' | translate}}</h2>
              </ion-label>

              <i class="fa-regular fa-chevron-right icon-list"></i>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="!userProvider.hasConfig(107);" (click)="editarReuniao(reuniao.id);">
        <ion-col size="12">
          <ion-list lines="full">
            <ion-item>
              <ion-note slot="start">
                <i class="fa-solid fa-pen-to-square icon-list icon-gerenciar"></i>
              </ion-note>

              <ion-label>
                <h2 class="text-list" *ngIf="!readOnly">{{'Editar Reunião' | translate}}</h2>
                <h2 class="text-list" *ngIf="readOnly">{{'Reunião' | translate}}</h2>
              </ion-label>

              <i class="fa-regular fa-chevron-right icon-list"></i>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="!userProvider.hasConfig(172);" (click)="presencaParticipantes(reuniao.id);">
        <ion-col size="12">
          <ion-list lines="full">
            <ion-item>
              <ion-note slot="start">
                <i class="fa-solid fa-square-check icon-list icon-gerenciar"></i>
              </ion-note>

              <ion-label>
                <h2 class="text-list" *ngIf="!readOnly">{{'Presença Participantes' | translate}}</h2>
                <h2 class="text-list" *ngIf="readOnly">{{'Participantes' | translate}}</h2>
              </ion-label>

              <i class="fa-regular fa-chevron-right icon-list"></i>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="!userProvider.hasConfig(167);" (click)="presencaVisitantes(reuniao.id);">
        <ion-col size="12">
          <ion-list lines="full">
            <ion-item>
              <ion-note slot="start">
                <i class="fa-solid fa-user-check icon-list icon-gerenciar"></i>
              </ion-note>

              <ion-label>
                <h2 class="text-list" *ngIf="!readOnly">{{'Presença Visitantes' | translate}}</h2>
                <h2 class="text-list" *ngIf="readOnly">{{'Visitantes' | translate}}</h2>
              </ion-label>

              <i class="fa-regular fa-chevron-right icon-list"></i>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="!userProvider.hasConfig(168);" (click)="visitanteEsporadico(reuniao.id);">
        <ion-col size="12">
          <ion-list lines="full">
            <ion-item>
              <ion-note slot="start">
                <i class="fa-solid fa-user-clock icon-list icon-gerenciar"></i>
              </ion-note>

              <ion-label>
                <h2 class="text-list">{{'Visitantes Esporádicos' | translate}}</h2>
              </ion-label>

              <i class="fa-regular fa-chevron-right icon-list"></i>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="!userProvider.hasConfig(174) && resumoData;" (click)="resumo(reuniao.id);">
        <ion-col size="12">
          <ion-list lines="full">
            <ion-item>
              <ion-note slot="start">
                <i class="fa-solid fa-square-list icon-list icon-gerenciar"></i>
              </ion-note>

              <ion-label>
                <h2 class="text-list">{{'Resumo da Reunião' | translate}}</h2>
              </ion-label>

              <i class="fa-regular fa-chevron-right icon-list"></i>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="!userProvider.hasConfig(169);" (click)="addFoto(reuniao.id);">
        <ion-col size="12">
          <ion-list lines="full">
            <ion-item>
              <ion-note slot="start">
                <i class="fa-solid fa-camera icon-list icon-gerenciar"></i>
              </ion-note>

              <ion-label>
                <h2 class="text-list">{{'Fotos da Reunião' | translate}}</h2>
              </ion-label>

              <i class="fa-regular fa-chevron-right icon-list"></i>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="!userProvider.hasConfig(170);" (click)="check(reuniao.id);">
        <ion-col size="12" *ngIf="!readOnly">
          <ion-list lines="full">
            <ion-item>
              <ion-note slot="start">
                <i class="fa-solid fa-circle-check icon-list icon-gerenciar"></i>
              </ion-note>

              <ion-label>
                <h2 class="text-list">{{'Check-in e Check-out' | translate}}</h2>
              </ion-label>

              <i class="fa-regular fa-chevron-right icon-list"></i>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="config" (click)="excluir(reuniao.id);">
        <ion-col size="12">
          <ion-list lines="full">
            <ion-item>
              <ion-note slot="start">
                <i class="fa-solid fa-trash-can icon-list icon-gerenciar"></i>
              </ion-note>

              <ion-label>
                <h2 class="text-list">{{'Excluir Reunião' | translate}}</h2>
              </ion-label>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>